import * as React from 'react';
import type { SVGProps } from 'react';
const SvgAddress = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="currentColor"
    {...props}
  >
    <path
      fill="currentColor"
      d="m21.771 11.448-9.219-9.22a.781.781 0 0 0-1.104 0l-9.22 9.22a.781.781 0 1 0 1.106 1.104l.202-.202v8.869c0 .431.35.781.782.781h15.364c.432 0 .782-.35.782-.781v-8.87l.202.204a.781.781 0 0 0 1.105-1.105Zm-7.48 8.99H9.709v-4.584h4.584v4.584Zm4.61 0h-3.047v-5.365a.781.781 0 0 0-.781-.781H8.927a.781.781 0 0 0-.781.781v5.364H5.099v-9.65L12 3.887l6.901 6.9v9.65Z"
    />
  </svg>
);
export default SvgAddress;
